
import { Vue, Component } from 'vue-property-decorator';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';

@Component({
  components: {
    DeviceLayout,
  },
})
export default class SensorLevelPreview extends Vue {
  level = 30

  get previewNameLang() {
    return this.$t('devices.SensorLevel.previewName');
  }
}
